import { useQuery } from '@tanstack/react-query'
import { useTRPC, type TRPCOutputs } from '~/utils/trpc'

export type StationLeakV0Episode = TRPCOutputs['ops']['stations']['leakV0Episodes'][number]

const EPISODES_STALE_TIME_MS = 5 * 60_000

/** Newest onset first, as the procedure orders them. */
export const useLeakV0Episodes = (stationId: string) => {
  const trpc = useTRPC()

  return useQuery(
    // The procedure parses every episode row strictly and throws on the first malformed one, so a
    // failure here is deterministic and a retry only repeats it.
    trpc.ops.stations.leakV0Episodes.queryOptions(
      { stationId },
      { staleTime: EPISODES_STALE_TIME_MS, retry: false, refetchOnWindowFocus: false }
    )
  )
}
